function outputmoney(number) {
  number = number.toString().replace(/\\,/g, "");
  if (isNaN(number) || number == "") return "";
  number = Math.round(number * 100) / 100;
  if (number < 0)
    return (
      "-" +
      outputdollars(Math.floor(Math.abs(number) - 0) + "") +
      outputcents(Math.abs(number) - 0)
    );
  else
    return outputdollars(Math.floor(number - 0) + "") + outputcents(number - 0);
}
//格式化金额
function outputdollars(number) {
  if (number.length <= 3) return number == "" ? "0" : number;
  else {
    var mod = number.length % 3;
    var output = mod == 0 ? "" : number.substring(0, mod);
    for (var i = 0; i < Math.floor(number.length / 3); i++) {
      if (mod == 0 && i == 0)
        output += number.substring(mod + 3 * i, mod + 3 * i + 3);
      else output += number.substring(mod + 3 * i, mod + 3 * i + 3);
    }
    return output;
  }
}
function outputcents(amount) {
  amount = Math.round((amount - Math.floor(amount)) * 100);
  return amount < 10 ? ".0" + amount : "." + amount;
}

function fmoney(s, n) {
  //s金额 n小数点后几位
  n = n > 0 && n <= 20 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\\.-]/g, "")).toFixed(n) + "";
  var l = s
      .split(".")[0]
      .split("")
      .reverse(),
    r = s.split(".")[1];
  var t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
  }
  return (
    t
      .split("")
      .reverse()
      .join("") +
    "." +
    r
  );
}
// 测试
console.log(outputmoney(1)); // 100.00
// console.log(outputmoney(1000.191)); // 1,000.19
// console.log(outputmoney(1000.199)); // 1,000.20
export default {
  outputcents,
  outputdollars,
  outputmoney,
  fmoney
};
